import Template from './EventSummaryDemographicsBreakdownItemView.njk';
import Marionette from "backbone.marionette";

export const EventSummaryDemographicsBreakdownItemView = Marionette.View.extend({
  template: Template,
    tagName: 'span',

    modelEvents: {
        'change:quantity': 'onQuantityChange'
    },

    onQuantityChange() {
        this.render();
    }
});


// WEBPACK FOOTER //
// ./src/js/view/components/EventSummary/EventSummaryDemographicsBreakdownItemView.js